module.exports = __webpack_public_path__ + "img/marker-oil-refinery-red.8a56df10.png";